import { FirebaseApp, initializeApp } from 'firebase/app'

import { firebaseConfig } from '@/config/firebase'
import { ENVIRONMENT } from '@/constants/env'

export const firebaseApp =
  ENVIRONMENT === 'development'
    ? ({} as FirebaseApp)
    : initializeApp(firebaseConfig)
